import React, { useEffect, useRef, useState } from "react";
import { API_URL } from "../../config/constants";
import { SearchWrapper, SearchInput, Dropdown, DropdownItem, SelectedUser } from "./styles";

const roleLabel = { patient: "Paciente", therapist: "Terapeuta" };

const UserSearch = ({ onSelect, selectedUser, onClear }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef();

  useEffect(() => {
    if (query.trim().length === 0) { setResults([]); setOpen(false); return; }

    const token = localStorage.getItem("token");
    const timeout = setTimeout(() => {
      fetch(`${API_URL}/users?search=${encodeURIComponent(query)}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((r) => r.json())
        .then((data) => { setResults(Array.isArray(data) ? data : []); setOpen(true); })
        .catch(() => {});
    }, 300);

    return () => clearTimeout(timeout);
  }, [query]);

  // Cerrar al hacer click fuera
  useEffect(() => {
    const handleClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleSelect = (user) => {
    onSelect(user);
    setQuery("");
    setOpen(false);
  };

  if (selectedUser) {
    return (
      <SelectedUser>
        <span>{selectedUser.first_name} {selectedUser.last_name}</span>
        <span className="role">{roleLabel[selectedUser.role] || selectedUser.role}</span>
        <button onClick={onClear} title="Cambiar usuario">✕</button>
      </SelectedUser>
    );
  }

  return (
    <SearchWrapper ref={wrapperRef}>
      <SearchInput
        placeholder="Buscar usuario..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => results.length > 0 && setOpen(true)}
      />
      {open && results.length > 0 && (
        <Dropdown>
          {results.map((u) => (
            <DropdownItem key={u.id} onClick={() => handleSelect(u)}>
              <span>{u.first_name} {u.last_name}</span>
              <span className="role">{roleLabel[u.role] || u.role}</span>
            </DropdownItem>
          ))}
        </Dropdown>
      )}
      {open && results.length === 0 && query.length > 0 && (
        <Dropdown>
          <DropdownItem style={{ color: "rgba(255,255,255,0.4)", cursor: "default" }}>
            Sin resultados
          </DropdownItem>
        </Dropdown>
      )}
    </SearchWrapper>
  );
};

export default UserSearch;
